<template>
  <div class="data-list-container vs-con-loading__container" id="order-order-list">
    <!-- <div
      slot="header"
      class="flex flex-wrap-reverse items-center flex-grow justify-between w-row mb-6"
    >
      <div class="flex flex-wrap-reverse items-center flex-grow justify-end">
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer item-per-page-dropdown"
          style="width: 140px"
        >
          <div
            class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2">{{filter.title}}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu style="width: 140px;">
            <vs-dropdown-item v-for="(item, i) in filterOptions" :key="i">
              <span class="w-full flex justify-between">
                {{item.title}}
                <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" />
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <div class="con-input-search vs-table--search ml-4">
          <input
            type="text"
            class="input-search vs-table--search-input rounded-item border-custom"
            placeholder="Name, phone"
          />
          <i class="vs-icon notranslate icon-scale material-icons null">search</i>
        </div>
      </div>
    </div>-->
    <vs-table :data="orderList">
      <template slot="thead">
        <vs-th class="w-1/12 center-title text-center">Order ID</vs-th>
        <vs-th class="w-4/12 center-title text-center" style="min-width: 185px">Order at</vs-th>
        <vs-th class="w-3/12 center-title">Customer</vs-th>
        <vs-th class="w-2/12 center-title" style="min-width: 145px">Status</vs-th>
        <vs-th class="w-2/12" style="min-width: 160px"></vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td @click.native="openDetailModal(tr)" :data="tr.id">{{ tr.id }}</vs-td>
          <vs-td @click.native="openDetailModal(tr)" :data="tr.category">
            <p class="text-center">{{ changeFormat(tr.created_at) }}</p>
            <p class="text-center">{{ getTime(tr.created_at) }}</p>
          </vs-td>
          <vs-td
            @click.native="openDetailModal(tr)"
            :data="tr.customer_name"
            class="pl-4 text-center"
          >{{ tr.customer_name }}</vs-td>
          <vs-td @click.native="openDetailModal(tr)" :data="tr.order_status">
            <!-- <vs-alert :color="getStatusColor(tr.order_status)" class="flex align-center justify-center order-status-alert">{{getStatusText(tr.order_status)}}</vs-alert> -->
            <div class="flex-center">
              <vs-chip
                :color="getStatusColor(tr.order_status)"
              >{{getStatusText(tr.order_status).toUpperCase()}}</vs-chip>
            </div>
          </vs-td>
          <vs-td>
            <vs-button
              v-show="tr.order_status == ORDER_STATUS_CONFIRM"
              class="text-sm"
              color="primary"
              @click="markAsReady(tr)"
              style="padding: 0.75rem 1rem"
            >
              Mark as Ready
              <!-- <p>Ready</p> -->
            </vs-button>
          </vs-td>
        </vs-tr>
        <!-- <span @click="openDetailModal">open test modal</span> -->
      </template>
    </vs-table>

    <div v-if="orderData._meta && orderData._meta.pageCount">
      <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(orderData._meta.pageCount)"
        :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
    </div>
  </div>
</template>
<script>
import {changeFormatHelper} from '../../helper/datetimeHelper';
import moment from 'moment';
export default {
  name: "order-order-list",
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      required: true,
      default: 10
    }
  },
  data() {
    return {
      order_list: [
        {
          id: 1,
          created_at: "03/31/2020",
          customer_name: "Bond Nguyen",
          status: 1
        }
      ],
      filterOptions: [
        { id: 1, title: "All Category", name: "all" },
        { id: 2, title: "New", name: "new" },
        { id: 3, title: "At risk", name: "atrisk" }
      ],
      filter: { id: 1, title: "All Category", name: "all" },
      ORDER_STATUS_CANCEL: 99,
      ORDER_STATUS_NEW: 0,
      ORDER_STATUS_CONFIRM: 1,
      ORDER_STATUS_IN_PROGRESS: 2,
      ORDER_STATUS_READY: 3,
      ORDER_STATUS_PICKED_UP: 4,
      ORDER_STATUS_DELIVERED: 5,
      ORDER_STATUS_COMPLETED: 6,
      // currentPage: 1,
      page_key: 0
    };
  },
  computed: {
    orderList() {
      return this.$store.getters["order/orderList"];
    },
    orderData() {
      return this.$store.getters["order/orderData"];
    }
  },
  methods: {
    changeFormat(date) {
      if(date) {
        return changeFormatHelper(date);
      } else {
        return 'N/A';
      }
    },
    getTime(date) {
      if(date) {
        return moment(date).format('hh:mm A');
      } else {
        return '';
      }
    },
    changePage(currentPage) {
      this.$emit('pageChanged', currentPage);
      this.page_key++;
    },
    openDetailModal(order) {
      this.$emit("openDetailModal", order);
    },
    getStatusColor(status) {
      if (status == this.ORDER_STATUS_NEW) {
        return "red";
      } else if (status == this.ORDER_STATUS_CONFIRM) {
        return "green";
      } else if (status == this.ORDER_STATUS_READY) {
        return "blue";
      } else if (status == this.ORDER_STATUS_PICKED_UP) {
        return "grey";
      } else {
        ("grey");
      }
    },
    getStatusText(status) {
      if (status == this.ORDER_STATUS_NEW) {
        return "New";
      } else if (status == this.ORDER_STATUS_CONFIRM) {
        return "In progress";
      } else if (status == this.ORDER_STATUS_READY) {
        return "Ready";
      } else {
        return "Finish";
      }
    },
    markAsReady(order) {
      this.$vs.dialog({
        type: "confirm",
        title: "Confirmation",
        text: "Are you sure to mark this order as Ready?",
        accept: () => {
          let obj = {
            status: this.ORDER_STATUS_READY,
            id: order.id,
            page: 1,
            'per-page': this.itemsPerPage
          };
          this.$store.dispatch("order/ORDER_UPDATE_STATUS", obj).then(() => {
            // this.$vs.notify({
            //   title: "Update status",
            //   text: "Order has been marked as ready!",
            //   color: "success",
            //   position: "top-right"
            // });
            // this.$store.dispatch("order/ORDER_LIST", {page: this.currentPage, 'per-page': this.itemsPerPage});
            this.$emit('ChangeToFirstPage');
          });
        }
      });
    }
    // getOrderDetail(order) {
    //   this.$emit('GetOrderDetail', order);
    // }
  }
  // methods: {
  //   getNextStatus(status) {
  //     if(status == this.ORDER_STATUS_NEW) {
  //       return this.ORDER_STATUS_CONFIRM;
  //     } else if(status == this.ORDER_STATUS_CONFIRM) {
  //       return this.ORDER_STATUS_READY
  //     } else if(status == this.ORDER_STATUS_READY) {
  //       return this.ORDER_STATUS_PICKED_UP
  //     } else {
  //       return this.ORDER_STATUS_COMPLETED;
  //     }
  //   },
  //   getStatusColor(status) {
  //     if(status == this.ORDER_STATUS_NEW) {
  //       return 'success';
  //     } else if(status == this.ORDER_STATUS_CONFIRM) {
  //       return 'primary';
  //     } else if(status == this.ORDER_STATUS_READY) {
  //       return 'danger';
  //     } else if(status == this.ORDER_STATUS_PICKED_UP) {
  //       return 'primary';
  //     } else {
  //       'primary'
  //     }
  //   },
  //   getStatusText(status) {
  //     if(status == this.ORDER_STATUS_NEW) {
  //       return 'New';
  //     } else if(status == this.ORDER_STATUS_CONFIRM) {
  //       return 'In progress';
  //     } else if(status == this.ORDER_STATUS_READY) {
  //       return 'Ready';
  //     } else {
  //       return 'Finish'
  //     }
  //   },
  //   getStatusTextForButton(status) {
  //     if(status == this.ORDER_STATUS_CONFIRM) {
  //       return 'Confirm';
  //     } else if(status == this.ORDER_STATUS_READY) {
  //       return 'Ready';
  //     } else if(status == this.ORDER_STATUS_PICKED_UP) {
  //       return 'Pickup';
  //     } else {
  //       return 'Finish';
  //     }
  //   }
  // }
};
</script>
